import React from "react";

/** Mobile-first shell that caps width on desktop to keep the mobile UX feel. */
export const PhoneShell = ({ children, className = "" }) => (
    <div className="min-h-screen w-full bg-[#F9F6F0] flex justify-center">
        <div
            className={`w-full max-w-md min-h-screen bg-[#F9F6F0] relative overflow-hidden ${className}`}
        >
            {children}
        </div>
    </div>
);

export default PhoneShell;
